// This example shows you how to set up React Stripe.js and use Elements.
// Learn how to accept a payment using the official Stripe docs.
// https://www.stripe.com/docs/payments/integration-builder

import React from "react";
import "./css/normalize.css";
import "./css/global.css";

import logo from "./assets/logo.png";
import googlePlay from "./assets/googlePlay.png";
import appStore from "./assets/appStore.png";

const iOSLink = "https://devlavoria.page.link/tnrV";
const androidLink = "https://devlavoria.page.link/oym1";

const Worker = () => {
  return (
    <div className="AppWrapper">
      <img className="logo" src={logo} alt="logo" />
      <h1 className="title">Καλωσήλθατε στο LAVORIA</h1>
      <div className="description">
        Βρείτε γρήγορα εποχιακό και μόνιμο προσωπικό σε μία εφαρμογή
      </div>
      <div className="buttonsWrapper">
        <a href={androidLink}>
          <img src={googlePlay} alt="googlePlay" />
        </a>
        <a href={iOSLink}>
          <img src={appStore} alt="appStore" onClick />
        </a>
      </div>
    </div>
  );
};

export default Worker;
